import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "sidebar",
  style: {"max-width":"450px","width":"100%"}
}
const _hoisted_2 = {
  key: 0,
  class: "card"
}
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.item)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputs || [], (sideBarItem, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "mb-4",
                key: index
              }, [
                (!sideBarItem.hideLabel)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 0,
                      class: "mb-1",
                      textContent: _toDisplayString(sideBarItem.label)
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  innerHTML: sideBarItem.format ? sideBarItem.format(_ctx.item) : _ctx.item[sideBarItem.name]
                }, null, 8, _hoisted_5)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}